<template>
  <div class="policy_container">
    <p class="policy_margin_bottom policy_size_20 policy_title_center policy_font_blod">全屋記隱私協議</p>
    <p class="policy_p">歡迎使用全屋記全景相機產品及服務。</p>
    <p class="policy_p">秦創科技有限公司（以下或稱「我們」）深知個人資訊對您的重要性，非常注重保護用戶（「您」）的個人資訊及隱私，並盡全力保護您的個人資訊安全可靠，我們致力於維持您對我們的信任，並遵守業界安全標準，採取相應的安全措施來保護您的個人資訊。在使用我們的產品和服務前，請您務必仔細閱讀並充分瞭解全屋記全景相機隱私政策（以下簡稱「本政策」）。</p>
    <p class="policy_p">未滿18週歲的未成年人請務必在監護人的陪同下閱讀本政策，並確保已徵得監護人明確同意後，再使用我們的服務並提供您的個人資訊。</p>
    <p class="policy_p">若您使用我們的服務，則表示您或您的監護人已理解本政策，並同意按照本政策規定的方式對您的個人資訊進行收集和使用。</p>
    <p class="policy_p">本政策將說明您瞭解以下內容：</p>
    <p>一、適用範圍<br/>二、Cookie使用<br/>三、共用資訊<br/>四、轉讓資訊<br/>五、資訊披露<br/>六、資訊處理、存儲期限以及銷毀方法<br/>七、資訊保護<br/>八、用戶權益<br/>九、未滿18週歲的未成年人信息<br/>十政策變更<br/>十一、法律及管轄<br/>十二、聯繫我們<br/>十三、附錄-許可權申請、使用目的及業務場景<br/></p>
    <p class="policy_font_700">一、適用範圍</p>
    <p class="policy_font_700">(一)向您提供發佈作品功能/服務</p>
    <p class="policy_font_700">1.驗證登錄</p>
    <p class="policy_p">當您使用全屋記全景相機的「全景空間」功能創建作品時，我們需要您提供手機號碼以及驗證碼匹配結果進行身份驗證。我們收集這些資訊是用於為您提供帳號登錄服務以及創建作品服務。您應知悉，手機號碼和驗證碼匹配結果屬於您的個人敏感資訊，請您謹慎考慮後再提供。<br>如您僅需要拍攝全景照片、查看相冊等基本功能及服務，您無需設置帳號並提供上述資訊</p>
    <p class="policy_font_700">(二)設備資訊</p>
    <p class="policy_p">1.為了保障我們服務的安全運行，以及保障您的資訊安全、排查產品故障、記錄有關服務使用的統計資料、優化服務所需的統計分析，我們會收集您的設備型號、IMEI、網路設備硬體位址
（MAC）、軟體版本號、藍牙（僅SDK）、WLAN連接、操作日誌等資訊，這些資訊是我們提供服務和保障產品正常運行所必須收集的基本資訊。
我們收集、使用上述資訊時，資料分析僅對應特定的、無法直接關聯使用者身份的編碼，無法也絕不會與你的真實身份相關聯。</p>
    <p class="policy_p">2.設備許可權調用。為了能正常讀取設備識別號碼，保證您能正常保存全景相片、或將全景相機端的緩存資訊下載到手機上使用，我們會向系統申請「讀取手機狀態和身份、啟用寫入外部存儲卡許可權」。申請前我們會徵詢您的同意，您可以選擇「允許」或「禁止」許可權申請；您可以在設備的設置功能中選擇關閉部分或全部許可權，從而拒絕收集相應的個人資訊，但選擇禁止或關閉部分或全部許可權時，您可能無法正常使用全屋記全景相機。</p>
    <p class="policy_font_700">(三)位置資訊</p>
    <p class="policy_p">當您使用全屋記全景相機的編輯作品資訊中添加位置功能，我們會請求您授權地理位置這一敏感許可權，如經緯度資訊、網路位置、IP位址、粗略位置等資訊。您可以在手機【選擇位置】-【應用管理】-【許可權】，開啟或關閉位置資訊，精確位置資訊是個人敏感資訊，我們將精確位置資訊設置為預設關閉狀態，若您不向我們授權，我們將不會收集您的精確位置資訊，且不會影響您正常使用其他功能及服務。</p>
    <p class="policy_font_700">(四)基於正常使用功能及服務的個人資訊</p>
    <p class="policy_p">1.核心功能：當您使用全景拍照、相冊、全景空間等業務功能時，我們將需要獲取您的相機、存儲、麥克風許可權。當您在啟動彈窗處選擇並點擊【同意/開啟】即視為您授權我們可以訪問、獲取您的該等個人資訊，如您拒絕提供會使您無法使用該功能。</p>
    <p class="policy_p">2.識別功能：我們可能會使用識別技術來識別您的相冊、全景空間中具有特徵點的資訊。我們識別特徵點資訊僅是為了提供更具針對性服務，特別是全景空間中的物品資訊及距離資訊。我們識別該類資訊後即作識別處理，不會用於識別任何特定用戶。</p>
    <p class="policy_p">3.推送服務：為更好地瞭解並使用我們的產品和服務，我們將會向您的手機推送我們的產品、服務、行銷資訊，但如果您不想接收我們給您發送的此類資訊，您可在手機-【設置】-【通知】拒絕接收。</p>
    <p class="policy_p">4.客戶服務：當您向我們提起投訴、進行諮詢或申訴時，為了方便與您聯繫或幫助您解決問題，我們可能需要您提供姓名、手機號碼、電子郵件及其他有效的聯繫方式等個人資訊。如您拒絕提供上述資訊，我們可能無法向您及時回饋相關處理結果。為了更好的讓您瞭解我們的產品與服務，我們可能會向您進行相關的問卷調查，調查問卷資料僅用於我們統計匯總、優化運營、提升用戶體驗，我們不會透露您的個人資訊。</p>
    <p class="policy_p">5.個性化推薦：當您使用全屋記全景相機的全景拍照、全景空間功能時，我們會收集這些行為產生的資料並上報到伺服器。我們收集這些資訊是為了向您提供更便捷、更符合您個性化需求的資訊展示、搜索及推送服務，我們會根據您使用全屋記全景相機時的選擇的個人標籤，使用資訊，提取您的偏好特徵，用於展示、推送資訊和個性化推薦。</p>
    <p class="policy_p">6.發佈與互動：
當您使用全屋記全景相機的「全景空間」功能時，我們會收集您的流覽和點擊操作記錄。您的流覽和點擊操作記錄屬於個人敏感資訊，我們收集這些資訊是為了向您提供資訊展示服務，向您推薦可能感興趣的內容。您的流覽、收藏、點贊、關注記錄資訊會被存儲在我們的伺服器中，我們不會將該資訊用於其他目的或向協力廠商分享。
當您使用「全景空間」功能創建作品時，我們需要驗證您的身份，您發佈的作品資訊經上傳後僅供用戶展示，我們不會將該資訊用於其他目的或與協力廠商分享。
</p>
    <p class="policy_font_700">二、Cookie使用</p>
    <p class="policy_font_700">(一)關於Cookie和同類技術</p>
    <p class="policy_p">Cookie是包含字串的小檔，在您登入和使用網站或其他網路內容時發送、存放在您的電腦、移動設備或其他裝置內（通常經過加密）。Cookie同類技術是可用於與Cookie類似用途的其他技術，例如：WebBeacon、Proxy、嵌入式腳本等。</p>
    <p class="policy_font_700">(二)我們如何使用Cookie和同類技術</p>
    <p class="policy_p">當您使用全屋記全景相機的產品和服務時，我們可能會使用Cookie和同類技術向您的設備發送一個或多個Cookie或匿名識別字，以收集和存儲您訪問、使用功能及服務時的資訊。我們使用Cookie和同類技術主要為了您使用我們的功能及服務的必要、簡化您重複操作的步驟（如註冊、登錄）、便於您查看使用歷史、向您提供更切合您個人需要的服務內容和您可能更感興趣的內容、保護您的資訊和帳號安全性、改善我們的產品和服務等。我們承諾，我們不會將Cookie用於本隱私政策所述目的之外的任何其他用途。</p>
    <p class="policy_font_700">三、共用資訊</p>
    <p class="policy_p">我們不會向任何公司、組織、個人共用您的個人資訊，但以下情況除外：</p>
    <p class="policy_font_700">(一)在獲取明確同意的情況下共用：獲得您的明確同意後，我們會與其他方共用您的個人資訊。</p>
    <p class="policy_font_700">(二)在法定條件下共用：我們可能會根據法律法規規定、訴訟爭議解決需要、按照政府主管部門或司法機關依法提出的強制要求，對外共用您的個人資訊。</p>
    <p class="policy_font_700">(三)在法律要求或允許的範圍內，為了保護全屋記全景相機及用戶或社會公眾的利益、財產或安全免遭損害而有必要提供您的個人資訊給協力廠商。</p>
    <p class="policy_font_700">(四)與協力廠商合作方的共用</p>
    <p class="policy_p">為了使您能夠接收資訊推送、在協力廠商平臺分享資訊、使我們通過分析用戶行為，提供更好的服務和使用者體驗。全屋記全景相機應用中接入了協力廠商合作方，上述合作方包括部分社交平臺（如google、line、facebook、instagram……）和協力廠商資料處理分析平臺推送等。我們會以高度的勤勉義務對待您的資訊，審慎評估協力廠商收集、使用資訊的目的，會對協力廠商獲取資訊的SDK(軟體工具開發包)進行嚴格的安全監測，以保證資料安全。我們的合作方包括以下類型：</p>
    
    <p class="policy_font_700">1.廣告服務類合作方</p>
    <p class="policy_p">在符合相關法律法規的前提下，我們可能會允許本服務的協力廠商廣告方收集使用者的廣告識別資訊。使用場景描述：廣告推送，共用的個人資訊類型：設備資訊、IMEI、MAC位址、AndroidID、AdID、IDFV、ICCID、網路及位置相關資訊。我們將共用的資訊去標識化處理，我們不會將您的個人敏感資訊與合作方共用。</p>
    <p class="policy_font_700">2.技術類合作方</p>
    <p class="policy_p">為我們提供技術支持的合作方，會向我們的使用者收集相關個人資訊用於實現其所支援的服務，合作方將基於其資訊安全規則完成去標識化處理的個人資訊，以說明我們統計和分析資料，評估程式效果。同時，還有其他提供推送服務的合作方，會向我們的使用者收集基於其資訊安全規則完成去標識化處理的個人資訊，以說明我們向使用者推送消息和提供個性化推薦服務。
技術支援類合作方收集的相關資訊具體如下：</p>
    <p class="policy_p">協力廠商SDK名稱：分享庫（google、line、facebook、instagram……）</p>
    <p class="policy_p">使用場景描述：用戶自主將拍攝全景空間分享於協力廠商平臺</p>
    <p class="policy_p">共用的個人資訊類型：唯一設備識別碼（IMEI；設備MAC位址；AndroidID；IMSI；ICCID);</p>
    <p class="policy_font_700">3.協力廠商合作方的官網連結如下：</p>
    <p class="policy_p">Line SDK官網連結：https://developers.line.biz/zh-hant/docs/messaging-api/overview/</p>
    <p class="policy_font_700">四、轉讓資訊</p>
    <p class="policy_p">我們不會轉讓您的個人資訊給任何協力廠商。隨著我們業務持續發展，產品和服務的完善，您的個人資訊可能會被轉移，在發生前述變更時，我們會將受讓人資訊以及委託業務內容提前告知您。</p>
    <p class="policy_font_700">五、資訊披露</p>
    <p class="policy_p">原則上，在未事先徵得您同意的前提下，我們不會將您的個人資訊公開披露。但我們可能基於以下目的披露您的個人資訊：</p>
    <p class="policy_font_700">(一)遵守適用的法律法規等有關規定；</p>
    <p class="policy_font_700">(二)遵守法院判決、裁定或其他法律程式的規定；</p>
    <p class="policy_font_700">(三)遵守相關政府機關或其他法定授權組織的要求；</p>
    <p class="policy_font_700">(四)有理由確信需要遵守法律法規等有關規定；</p>
    <p class="policy_font_700">(五)為執行相關服務協定或本政策、維護社會公共利益，為保護我們的客戶、我們或我們的關聯公司、其他您或僱員的人身財產安全或其他合法權益合理且必要的用途。</p>
    <p class="policy_font_700">六、資訊處理、存儲期限以及銷毀方法</p>
    <p class="policy_font_700">(一)存儲資訊的地點</p>
    <p class="policy_p">我們依照法律法規的規定，將在境內運營過程中收集和產生的您的個人資訊存儲於中華民國內。</p>
    <p class="policy_font_700">(二)存儲資訊的期限</p>
    <p class="policy_p">原則上，我們僅在為實現目的所必需的最短時間內保留您的個人資訊，超出必要期限的個人資訊我們會立即刪除、銷毀，但您行使刪除權、註銷帳戶的或法律法規另有規定的除外。如果我們將個人資訊轉讓給協力廠商的，我們會通知協力廠商進行銷毀處理。</p>
    <p class="policy_font_700">(三)銷毀方法</p>
    <p class="policy_p">列印出的紙質個人資訊將利用碎紙機銷毀，以電子檔形式保存的個人資訊將利用無法復原的技術方法永久刪除。</p>
    <p class="policy_font_700">七、資訊保護</p>
    <p>我們非常重視您個人資訊的安全，為保護您的個人資訊，我們採取以下措施：</p>
    <p class="policy_font_700">(一)我們會使用加密技術收集您設置的密碼，確保資料的保密性。</p>
    <p class="policy_font_700">(二)我們使用安全保護機制防止您的個人資訊遭到駭客攻擊、電腦病毒等而被洩露、毀損，我們會採取一切合理可行的技術措施，建立更完善的安全機制，保護您的個人資訊。</p>
    <p class="policy_font_700">(三)我們將處理個人資訊的員工數量控制到最少，並對員工進行資料安全的意識培養和安全能力的培訓。我們會嚴格遵循內部管理制度及相關法律法規規定。</p>
    <p class="policy_font_700">八、用戶權益</p>
    <p class="policy_font_700">(一)訪問、刪除、更正您的個人資訊</p>
    <p>1.關閉通知：您可通過手機【設置】-【通知】中關閉通知功能。</p>
    <p>2.在以下情形中，您可以向我們提出刪除個人資訊的請求：</p>
    <p>１如果我們處理個人資訊的行為違反法律法規；<br/>２如果我們收集、使用您的個人資訊，卻未徵得您的同意；<br/>３如果我們處理個人資訊的行為違反了與您的約定；<br/>４如果您不再使用我們的產品或服務，或者您登出了全屋記全景相機帳號；<br/>５如果我們終止服務及運營。<br/>
以上刪除請求一旦被回應，我們還將同時盡可能通知從全屋記全景相機獲得您個人資訊的主體，要求其及時刪除相應資訊，除非法律法規另有規定，或者這些主體獲得您的獨立授權。當您從我們的服務中刪除資訊後，我們可能不會立即從備份系統中刪除相應的資訊，我們將會在備份更新時刪除這些資訊或者實現匿名化處理。</p>
    <p class="policy_font_700">(二)撤回授權</p>
    <p class="policy_p">如果您希望撤銷同意我們收集、使用和披露您的其他個人資訊或者希望我們更正或刪除您的個人資訊，您可以隨時聯繫我們。<br/>聯繫方式：(04)2285-8011<br/>官方網站：www.qwhouse720.com<br/>我們將會在收到您的有效回饋後的合理時間內處理您的請求並停止收集、使用和披露您的個人資訊。<br/>請您理解並同意，當您撤回某些授權時，將導致與之相關的產品功能不可用，我們無法繼續為您提供撤回同意或授權所對應的特定功能和/或服務，並且您撤回授權的決定不會影響此前基於您的授權而開展的個人資訊處理。</p>
    <p class="policy_font_700">(三）撤回請求例外</p>
    <p>在以下情形中，按照法律法規要求，我們將無法回應您的請求：</p>
    <p>1、與我們履行法律法規規定的義務相關的；<br/>2、與國家安全、國防安全直接相關的；<br/>3、與公共安全、公共衛生、重大公共利益直接相關的；<br/>4、與刑事犯罪偵查、起訴、審判和執行判決等直接相關的；<br/>5、有充分證據表明個人資訊主體存在主觀惡意或濫用權利的；<br/>6、出於維護個人資訊主體或其他個人的生命、財產等重大合法權益但又很難得到本人授權同意的；<br/>7、響應您的請求將導致您或其他個人、組織的合法權益受到嚴重損害的；<br/>8、涉及商業秘密的。</p>
    <p class="policy_font_700">九、未滿18週歲的未成年人信息</p>
    <p>如果您是未滿18週歲的未成年人，我們將不會有意收集上述內容，請您在使用某些功能時，不要向我們授權。<br/>考慮到我們無法辨別網路訪問者的年齡，如有不滿18週歲的未成年人在未得到其父母或監護人同意的情況下向我們提供了個人資料，其父母或監護人可致電我們，以移除此類資訊。<br/>我們無意也不試圖收集未滿18週歲的未成年人資訊。</p>
    <p class="policy_font_700">十、政策變更</p>
    <p class="policy_p">我們可能會根據業務的調整、法律法規或政策的變化不定期修改或更新本政策，請根據提示定期查閱。我們將在變更生效前，通過在頁面顯著位置提示、向您發送短信、電子郵件等方式通知。<br/>在該種情況下，若您繼續使用我們的服務，即表示接受修訂的政策。如您不同意修訂後的隱私政策，您有權進行對個人資訊的修改或立即停止使用全屋記全景相機。</p>
    <p class="policy_font_700">十一、法律及管轄</p>
    <p>本政策的解釋及爭議解決均應適用中華民國法律。與本政策相關的任何糾紛，雙方應協商友好解決；若不能協商解決，任何一方均可將有關爭議提交至被告所在地有管轄權的法院管轄。</p>
    <p class="policy_font_700">十二、聯繫我們</p>
    <p>如果您在使用全屋記全景相機功能或服務中，有任何隱私保護相關的疑問、投訴、舉報等，請將問題郵寄至：台中市南區建成路1479號 2樓<br/>秦創科技有限公司<br/>或發送電子郵件至quanwuji720@gmail.com，或撥打電話至(04)2285-8011。<br/>我們將在十五日內進行回饋。</p>
    <p class="policy_font_700">十三、附錄-許可權申請、使用目的及業務場景</p>
    <p class="policy_font_700">(一)APP許可權：網路存取權限</p>
    <p>描述：訪問網路資訊<br/>使用目的及業務場景：將全景空間作品上傳</p>
    <p class="policy_font_700">(二)APP許可權：電話許可權</p>
    <p>描述：讀取手機狀態<br/>使用目的及業務場景：讀取手機狀態，涉及到使用者設備的IMEI資訊，用於識別使用者、保障您的帳號、網路、運營及系統安全，預防釣魚網站欺詐及木馬病毒及進行使用者資料統計（安裝、活躍度等）。</p>
    <p class="policy_font_700">(三)APP許可權：存儲許可權（寫入）</p>
    <p>描述：寫入外部存儲<br/>使用目的及業務場景：用於將使用者拍攝完畢的全景圖片保存到本地等的檔保存功能。</p>
    <p class="policy_font_700">(四)APP許可權：地理位置許可權</p>
    <p>描述：接收衛星的定位資訊<br/>使用目的及業務場景：獲取精確位置地理位置的許可權。用於用戶帶有地理位置的浮水印、素材的獲取、協力廠商廣告投放。</p>
    <p class="policy_font_700">(五)APP許可權：麥克風許可權</p>
    <p>描述：錄製聲音<br/>使用目的及業務場景：用於全景空間創建作品時候，添加語音熱點、背景音樂等功能。</p>
    <p class="policy_font_700">(六)APP許可權：存儲許可權（讀取）</p>
    <p>描述：讀取外部存儲<br/>使用目的及業務場景：讀取本地全景圖片檔，用於說明使用者進行全屏圖片預覽、全景空間作品創建。</p>
    <p class="policy_font_700">(七)APP許可權：通知許可權</p>
    <p>描述：向用戶發送通知<br/>使用目的及業務場景：向使用者推送平臺活動、行銷資訊等</p>
    <p class="policy_font_700">(八)APP許可權：下載安裝包</p>
    <p>描述：下載安裝包<br/>使用目的及業務場景：應用更新、推送安裝包等</p>
    <p class="policy_font_700">(九)APP許可權：相冊讀取、寫入許可權</p>
    <p>描述：允許使用手機相冊<br/>使用目的及業務場景：用於說明使用者進行全屏圖片預覽、全景空間作品創建，及個人帳戶頭像更換。</p>
  </div>
</template>

<script>
import "@/assets/css/policy.css";
  export default {
  }
</script>

<style lang="less" scoped>
p {
  margin-bottom: 5px;
  line-height: 1.8;
}
</style>